import {
  AUTH_TYPE,
  SERVICE_TYPE_KEY_VALUE
} from '../../../../../constants';
import {
  IQueryPathParam,
  IServiceDetailsValidationModel
} from '../../../../../models';
import { useSelector } from '../../../../../store/AppStore';
import AuthParamFields from './auth-param-fields/AuthParamFields';
import AuthType from './auth-type/AuthType';
import HeaderParamFields from './header-param-field/HeaderParamFields';
import UserNamePassword from './username-password/UserNamePassword';

interface IAuthBlockFieldsProps {
  formData: IServiceDetailsValidationModel;
  handleInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  authMethodChangeHandler: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  authMethodValue: string | undefined;
  headerParamListHandler: (data: IQueryPathParam[]) => void;
  headerParamList: IQueryPathParam[];
  requestParamListHandler: (data: IQueryPathParam[]) => void;
  requestParamList: IQueryPathParam[];
  queryPathParamListHandler: (data: IQueryPathParam[]) => void;
  queryPathParamList: IQueryPathParam[];
  authTypeChangeHandler: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  serviceTypeValue: string | undefined;
  authTypeValue: string | undefined;
  isViewMode: boolean
}
const AuthBlockFields = ({
  formData,
  handleInputChange,
  authMethodChangeHandler,
  authMethodValue,
  headerParamListHandler,
  headerParamList,
  requestParamListHandler,
  requestParamList,
  queryPathParamListHandler,
  queryPathParamList,
  authTypeChangeHandler,
  serviceTypeValue,
  authTypeValue,
  isViewMode
}: IAuthBlockFieldsProps) => {
  const { checkClicked } = useSelector((state) => state.serviceDetailsReducer);
  return (
    <div>
      {serviceTypeValue !== SERVICE_TYPE_KEY_VALUE.DB2 && checkClicked && (
      <AuthType
        authTypeChangeHandler={authTypeChangeHandler}
        serviceTypeValue={serviceTypeValue}
        authTypeValue={authTypeValue}
      />
    )}
      {authTypeValue === `${AUTH_TYPE[0].value}` && (
      <UserNamePassword
        formData={formData}
        handleInputChange={handleInputChange}
        isEdit={!isViewMode}
      />
    )}
      {authTypeValue === `${AUTH_TYPE[1].value}` && (
      <AuthParamFields
        isEdit={!isViewMode}
        formData={formData}
        handleInputChange={handleInputChange}
        authMethodChangeHandler={authMethodChangeHandler}
        authMethodValue={authMethodValue}
        headerParamListHandler={headerParamListHandler}
        headerParamList={headerParamList}
        requestParamListHandler={requestParamListHandler}
        requestParamList={requestParamList}
        queryPathParamListHandler={queryPathParamListHandler}
        queryPathParamList={queryPathParamList}
        serviceTypeValue={serviceTypeValue}
      />
    )}
      {authTypeValue === `${AUTH_TYPE[2].value}` && (
      <HeaderParamFields
        isEdit={!isViewMode}
        headerParamListHandler={headerParamListHandler}
        headerParamList={headerParamList}
      />
    )}
    </div>
);
    };

export default AuthBlockFields;
